const tabs = function(selector)
{
  let container = document.querySelector(selector)
  if(!container) return;
  let tabs = container.querySelectorAll('.tabs__tab')
  let panels = container.querySelectorAll('.tabs__panels')

  tabs.forEach(el => {
    el.addEventListener('click', change)
  });

  function change() {
    let panel = container.querySelector(`[data-id=${this.dataset.target}]`);
    let panelAcitve = container.querySelector('.tabs__panel--active');
    
    history.pushState(null, null, '?tab='+this.dataset.target);
    

    container.querySelector('.tabs__tab--active').classList.remove('tabs__tab--active');
    this.classList.add('tabs__tab--active');

    panelAcitve.classList.remove('tabs__panel--active');
    panel.classList.add('tabs__panel--active');
  }

  
}


export default tabs('.js--tabs');